"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intl = require("@kyruus/intl");
/**
 * Internationalized messages for this widget
 * These get passed through `React-Intl`
 * And should follow a format of:
 * Roses are {color_1} and violets are {color_2}
 */
var _default = exports.default = (0, _intl.defineMessages)({
  searchForAlternativeProviders: {
    id: 'gx.button.search_for_alternative_providers',
    description: 'Button label for searching alternative providers when PBV fails',
    defaultMessage: 'Search for Alternative Providers for {clinicalKeyword}'
  }
});